'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Container } from '@/components/container/container';
import { Button } from '@/components/ui/button/button';
import { Heading } from '@/components/ui/heading/heading';
import { useStaleChunkReload } from '@/utils/staleChunkReload';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // A chunk the deploy removed: one full navigation to the same URL, no screen.
  const reloading = useStaleChunkReload(error);

  useEffect(() => {
    console.error('Application error:', error);
  }, [error]);

  if (reloading) return null;

  return (
    <main className="min-h-screen flex items-center justify-center">
      <Container className="text-center">
        <span className="font-oswald text-[8rem] md:text-[12rem] leading-none font-bold text-action/10 select-none">
          500
        </span>
        <Heading variant="h1" className="mb-4 -mt-6">
          Wystąpił błąd
        </Heading>
        <p className="text-neutral-400 mb-8 max-w-md mx-auto">
          Przepraszamy, coś poszło nie tak. Spróbuj odświeżyć stronę lub wrócić na stronę główną.
        </p>
        <div className="flex gap-4 justify-center flex-wrap">
          <Button onClick={reset} variant="primary">
            Spróbuj ponownie
          </Button>
          <Button as={Link} href="/" variant="secondary">
            Strona główna
          </Button>
          <Button as={Link} href="/kontakt" variant="secondary">
            Kontakt
          </Button>
        </div>
      </Container>
    </main>
  );
}
